// extracted by mini-css-extract-plugin
module.exports = {"tableBody":"style_tableBody__PFeg2","buttonHiddenLarge":"style_buttonHiddenLarge__SxXhf"};